/**
 * Validates a mobile number using a specific regular expression.
 * @param mobile_no - The mobile number to validate.
 * @returns A boolean indicating if the mobile number is valid or not.
 */
export const isValidMobileNumber = (mobile_no: string): boolean => {
    const mobileNumberRegex = /^(17|16|77)\d{6}$/;
    return mobileNumberRegex.test(mobile_no);
};
